import { HexColorPicker } from 'react-colorful';
import styled from '@emotion/styled';
import * as tokens from '@tokens';

interface ColorPickerBoxProps {
  /**
   * Hex color
   */
  color?: string;

  /**
   * Callback for the color change.
   */
  onChange?: (color: string) => void;
}

const HexColorPickerWrapper = styled.div`
  .react-colorful .react-colorful {
    height: 160px;
    width: 92px;
  }
  .react-colorful .react-colorful__hue,
  .react-colorful .react-colorful__saturation {
    border-radius: ${tokens.radius.m};
  }
  .react-colorful .react-colorful__hue {
    margin-top: ${tokens.spacer.x1};
    height: ${tokens.spacer.x1pt5};
  }
  .react-colorful__interactive:focus .react-colorful__pointer {
    ${tokens.focus()};
  }
  .react-colorful .react-colorful__hue-pointer,
  .react-colorful .react-colorful__saturation-pointer {
    width: ${tokens.spacer.x1pt5};
    height: ${tokens.spacer.x1pt5};
    border: 2px solid ${tokens.BRAND_COLORS.white};
  }
`;

/**
 * The box of colors to chose from (without the input).
 *
 * ** WARNING** The usage of this component should be avoided.
 */
export const ColorPickerBox = ({
  color,
  onChange,
}: ColorPickerBoxProps): JSX.Element => (
  <HexColorPickerWrapper>
    <HexColorPicker color={color} onChange={onChange} />
  </HexColorPickerWrapper>
);
